import React from 'react';

import {useParams, useNavigate} from "react-router-dom";
import Form from '../../modules/Form';
import useFetch, {getUrl} from "../../modules/useFetch";
import {isNullOrUndefined} from "../../modules/strings";

import Button from "../../modules/Button"


const ResultNew = () => {
    //const [skak, setSkak] = useState({});


    const {id} = useParams();
    console.log({id});
    const {skak = {
      turnering: '',
      spillerNavn: '',
      spillerPoint: '',
      modSpillerNavn: '',
      modSpillerPoint: '',
    }} = useFetch('skak/' + id, isNullOrUndefined(id));
    const navigate = useNavigate();
      
   

    return (
        <>
            <h1>Nyt skak resultat</h1>
            <h3>Opret resultat</h3>

            <div>
                <Form
                    entity={skak}
                    onSubmitHandler={async newSkak => {
                        console.log(newSkak);
                        const response = await fetch(getUrl('skak'), {
                            method: isNullOrUndefined(newSkak.id) ? 'POST' : 'PUT',
                            body: JSON.stringify(newSkak),
                            headers: {
                              'Content-Type': 'application/json'
                            }
                          });
                              
                        if (response.ok) {
                          const res = await response.json()
                          console.log(res)
                          navigate('/results')
                        }
                      }}
                      onDeleteHandler={async (id) => {
                        if (!isNullOrUndefined(id)) {
                          await fetch(getUrl('skak'), {
                            method: 'DELETE',
                            body: JSON.stringify({id}),
                            headers: {
                              'Content-Type': 'application/json'
                            }
                          });
              
                          navigate('/results')
                        }
                      }}                            
                />
            </div>

            <p>
                <Button label="Opret" src="results" />
            </p>
        </>
    );
};

export default ResultNew;